define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"csi/store/Nodes",
	"csi/comm/PostRequest",
	"csi/form/Widget"
], function(declare,Memory,Nodes,PostRequest,Widget) {

	return declare(Widget, {
		_updateFieldVisibility: function(/*Field?*/field) {
			var bCopy = this.isCopy();
			var bEdit = this.isEdit();
			var is2D = this.defView.getFieldValue("IsTwoDim");

			if (!is2D && this.isEdit()) {
				is2D = this.getViewNode().IsTwoDim;
			}

			if (!field) {
				// Type should never be visible
				this.setFieldHidden("Type", true);

				// Dimension fields should be hidden when copying - they cannot be changed
				this.setFieldHidden("IsTwoDim", bEdit || bCopy);
				this.setFieldHidden("Dimension1Type", bEdit || bCopy);
			}

			// Dimension2 field changes visibility based on above rule and current IsTwoDim value
			this.setFieldHidden("Dimension2Type", bEdit || bCopy || !is2D);

			// OK fields should be hidden if working with 2D unless on edit form
			this.setFieldHidden("OKforMaterial", !bEdit && is2D);
			this.setFieldHidden("OKforSizeChart", !bEdit && is2D);

			return this.inherited(arguments);
		}
	});
});
